export const decodeJwt = (token: string): Record<'exp', number> => {
  const payloadBase64 = token.split('.')[1];
  const payloadDecoded = window.atob(payloadBase64);
  return JSON.parse(payloadDecoded);
};
